// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file transportation/v1/asset.proto (package transportation.v1, edition 2023)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema, Timestamp, Value } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty, file_google_protobuf_struct, file_google_protobuf_timestamp, file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Address, Base, ID, Weight } from "../../types_pb.js";
import { file_types } from "../../types_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file transportation/v1/asset.proto.
 */
export const file_transportation_v1_asset: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_google_protobuf_wrappers, file_google_protobuf_struct, file_types]);

/**
 * Asset message definition
 *
 * @generated from message transportation.v1.Asset
 */
export type Asset = Message<"transportation.v1.Asset"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID type_id = 2;
   */
  typeId?: ID;

  /**
   * @generated from field: transportation.v1.AssetStatus status = 3;
   */
  status: AssetStatus;

  /**
   * @generated from field: transportation.v1.AssetFillState fill_state = 4;
   */
  fillState: AssetFillState;

  /**
   * @generated from field: string identifier = 5;
   */
  identifier: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: types.Address current_location = 7;
   */
  currentLocation?: Address;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 8;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 9;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID facility_id = 10;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID account_address_id = 11;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.Weight tare_weight = 12;
   */
  tareWeight?: Weight;

  /**
   * @generated from field: string notes = 13;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 14;
   */
  customAttributes: { [key: string]: Value };

  /**
   * @generated from field: types.Base base = 15;
   */
  base?: Base;
};

/**
 * Describes the message transportation.v1.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 0);

/**
 * Request/Response messages for Asset queries
 *
 * @generated from message transportation.v1.GetAssetRequest
 */
export type GetAssetRequest = Message<"transportation.v1.GetAssetRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.GetAssetRequest.
 * Use `create(GetAssetRequestSchema)` to create a new message.
 */
export const GetAssetRequestSchema: GenMessage<GetAssetRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 1);

/**
 * @generated from message transportation.v1.GetAssetResponse
 */
export type GetAssetResponse = Message<"transportation.v1.GetAssetResponse"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;
};

/**
 * Describes the message transportation.v1.GetAssetResponse.
 * Use `create(GetAssetResponseSchema)` to create a new message.
 */
export const GetAssetResponseSchema: GenMessage<GetAssetResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 2);

/**
 * @generated from message transportation.v1.ListAssetsRequest
 */
export type ListAssetsRequest = Message<"transportation.v1.ListAssetsRequest"> & {
  /**
   * @generated from field: transportation.v1.ListAssetsFilter filter = 1;
   */
  filter?: ListAssetsFilter;

  /**
   * @generated from field: repeated transportation.v1.AssetSortOption sorting = 2;
   */
  sorting: AssetSortOption[];

  /**
   * @generated from field: int32 offset = 3;
   */
  offset: number;

  /**
   * @generated from field: int32 limit = 4;
   */
  limit: number;
};

/**
 * Describes the message transportation.v1.ListAssetsRequest.
 * Use `create(ListAssetsRequestSchema)` to create a new message.
 */
export const ListAssetsRequestSchema: GenMessage<ListAssetsRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 3);

/**
 * @generated from message transportation.v1.ListAssetsFilter
 */
export type ListAssetsFilter = Message<"transportation.v1.ListAssetsFilter"> & {
  /**
   * @generated from field: repeated types.ID ids = 1;
   */
  ids: ID[];

  /**
   * @generated from field: transportation.v1.AssetStatus status = 2;
   */
  status: AssetStatus;

  /**
   * @generated from field: google.protobuf.StringValue identifier = 3;
   */
  identifier?: string;

  /**
   * @generated from field: google.protobuf.StringValue search_term = 4;
   */
  searchTerm?: string;

  /**
   * @generated from field: types.ID organization_id = 5;
   */
  organizationId?: ID;

  /**
   * @generated from field: repeated types.ID type_ids = 6;
   */
  typeIds: ID[];

  /**
   * @generated from field: repeated types.ID account_ids = 7;
   */
  accountIds: ID[];

  /**
   * @generated from field: repeated types.ID account_address_ids = 8;
   */
  accountAddressIds: ID[];

  /**
   * @generated from field: repeated types.ID facility_ids = 9;
   */
  facilityIds: ID[];

  /**
   * @generated from field: google.protobuf.Timestamp last_updated_at = 10;
   */
  lastUpdatedAt?: Timestamp;
};

/**
 * Describes the message transportation.v1.ListAssetsFilter.
 * Use `create(ListAssetsFilterSchema)` to create a new message.
 */
export const ListAssetsFilterSchema: GenMessage<ListAssetsFilter> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 4);

/**
 * @generated from message transportation.v1.ListAssetsResponse
 */
export type ListAssetsResponse = Message<"transportation.v1.ListAssetsResponse"> & {
  /**
   * @generated from field: repeated transportation.v1.Asset assets = 1;
   */
  assets: Asset[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;
};

/**
 * Describes the message transportation.v1.ListAssetsResponse.
 * Use `create(ListAssetsResponseSchema)` to create a new message.
 */
export const ListAssetsResponseSchema: GenMessage<ListAssetsResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 5);

/**
 * Command messages
 *
 * @generated from message transportation.v1.CreateAssetRequest
 */
export type CreateAssetRequest = Message<"transportation.v1.CreateAssetRequest"> & {
  /**
   * @generated from field: transportation.v1.AssetInput input = 1;
   */
  input?: AssetInput;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.CreateAssetRequest.
 * Use `create(CreateAssetRequestSchema)` to create a new message.
 */
export const CreateAssetRequestSchema: GenMessage<CreateAssetRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 6);

/**
 * @generated from message transportation.v1.CreateAssetResponse
 */
export type CreateAssetResponse = Message<"transportation.v1.CreateAssetResponse"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;
};

/**
 * Describes the message transportation.v1.CreateAssetResponse.
 * Use `create(CreateAssetResponseSchema)` to create a new message.
 */
export const CreateAssetResponseSchema: GenMessage<CreateAssetResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 7);

/**
 * @generated from message transportation.v1.UpdateAssetRequest
 */
export type UpdateAssetRequest = Message<"transportation.v1.UpdateAssetRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: transportation.v1.AssetUpdateInput input = 2;
   */
  input?: AssetUpdateInput;

  /**
   * @generated from field: types.ID organization_id = 3;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.UpdateAssetRequest.
 * Use `create(UpdateAssetRequestSchema)` to create a new message.
 */
export const UpdateAssetRequestSchema: GenMessage<UpdateAssetRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 8);

/**
 * @generated from message transportation.v1.UpdateAssetResponse
 */
export type UpdateAssetResponse = Message<"transportation.v1.UpdateAssetResponse"> & {
  /**
   * @generated from field: transportation.v1.Asset asset = 1;
   */
  asset?: Asset;
};

/**
 * Describes the message transportation.v1.UpdateAssetResponse.
 * Use `create(UpdateAssetResponseSchema)` to create a new message.
 */
export const UpdateAssetResponseSchema: GenMessage<UpdateAssetResponse> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 9);

/**
 * @generated from message transportation.v1.DeleteAssetRequest
 */
export type DeleteAssetRequest = Message<"transportation.v1.DeleteAssetRequest"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID organization_id = 2;
   */
  organizationId?: ID;
};

/**
 * Describes the message transportation.v1.DeleteAssetRequest.
 * Use `create(DeleteAssetRequestSchema)` to create a new message.
 */
export const DeleteAssetRequestSchema: GenMessage<DeleteAssetRequest> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 10);

/**
 * Input messages
 *
 * @generated from message transportation.v1.AssetInput
 */
export type AssetInput = Message<"transportation.v1.AssetInput"> & {
  /**
   * @generated from field: types.ID id = 1;
   */
  id?: ID;

  /**
   * @generated from field: types.ID type_id = 2;
   */
  typeId?: ID;

  /**
   * @generated from field: transportation.v1.AssetStatus status = 3;
   */
  status: AssetStatus;

  /**
   * @generated from field: transportation.v1.AssetFillState fill_state = 4;
   */
  fillState: AssetFillState;

  /**
   * @generated from field: string identifier = 5;
   */
  identifier: string;

  /**
   * @generated from field: string description = 6;
   */
  description: string;

  /**
   * @generated from field: types.Address current_location = 7;
   */
  currentLocation?: Address;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 8;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 9;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID facility_id = 10;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID account_address_id = 11;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: types.Weight tare_weight = 12;
   */
  tareWeight?: Weight;

  /**
   * @generated from field: string notes = 13;
   */
  notes: string;

  /**
   * @generated from field: map<string, google.protobuf.Value> custom_attributes = 14;
   */
  customAttributes: { [key: string]: Value };
};

/**
 * Describes the message transportation.v1.AssetInput.
 * Use `create(AssetInputSchema)` to create a new message.
 */
export const AssetInputSchema: GenMessage<AssetInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 11);

/**
 * @generated from message transportation.v1.AssetUpdateInput
 */
export type AssetUpdateInput = Message<"transportation.v1.AssetUpdateInput"> & {
  /**
   * @generated from field: types.ID type_id = 1;
   */
  typeId?: ID;

  /**
   * @generated from field: transportation.v1.AssetStatus status = 2;
   */
  status: AssetStatus;

  /**
   * @generated from field: transportation.v1.AssetFillState fill_state = 3;
   */
  fillState: AssetFillState;

  /**
   * @generated from field: google.protobuf.StringValue identifier = 4;
   */
  identifier?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 5;
   */
  description?: string;

  /**
   * @generated from field: google.protobuf.StringValue current_location = 6;
   */
  currentLocation?: string;

  /**
   * @generated from field: google.protobuf.Timestamp last_location_time = 7;
   */
  lastLocationTime?: Timestamp;

  /**
   * @generated from field: types.ID account_id = 8;
   */
  accountId?: ID;

  /**
   * @generated from field: types.ID facility_id = 9;
   */
  facilityId?: ID;

  /**
   * @generated from field: types.ID account_address_id = 10;
   */
  accountAddressId?: ID;

  /**
   * @generated from field: google.protobuf.StringValue tare_weight = 11;
   */
  tareWeight?: string;

  /**
   * @generated from field: google.protobuf.StringValue notes = 12;
   */
  notes?: string;

  /**
   * @generated from field: google.protobuf.StringValue custom_attributes = 13;
   */
  customAttributes?: string;
};

/**
 * Describes the message transportation.v1.AssetUpdateInput.
 * Use `create(AssetUpdateInputSchema)` to create a new message.
 */
export const AssetUpdateInputSchema: GenMessage<AssetUpdateInput> = /*@__PURE__*/
  messageDesc(file_transportation_v1_asset, 12);

/**
 * AssetStatus enum
 *
 * @generated from enum transportation.v1.AssetStatus
 */
export enum AssetStatus {
  /**
   * @generated from enum value: ASSET_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_STATUS_INVENTORY = 1;
   */
  INVENTORY = 1,

  /**
   * @generated from enum value: ASSET_STATUS_DEPLOYED = 2;
   */
  DEPLOYED = 2,

  /**
   * @generated from enum value: ASSET_STATUS_IN_TRANSIT = 3;
   */
  IN_TRANSIT = 3,

  /**
   * @generated from enum value: ASSET_STATUS_OUT_OF_ORDER = 4;
   */
  OUT_OF_ORDER = 4,
}

/**
 * Describes the enum transportation.v1.AssetStatus.
 */
export const AssetStatusSchema: GenEnum<AssetStatus> = /*@__PURE__*/
  enumDesc(file_transportation_v1_asset, 0);

/**
 * AssetFillState enum
 *
 * @generated from enum transportation.v1.AssetFillState
 */
export enum AssetFillState {
  /**
   * @generated from enum value: ASSET_FILL_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_FILL_STATE_EMPTY = 1;
   */
  EMPTY = 1,

  /**
   * @generated from enum value: ASSET_FILL_STATE_FULL = 2;
   */
  FULL = 2,

  /**
   * @generated from enum value: ASSET_FILL_STATE_UNKNOWN = 3;
   */
  UNKNOWN = 3,
}

/**
 * Describes the enum transportation.v1.AssetFillState.
 */
export const AssetFillStateSchema: GenEnum<AssetFillState> = /*@__PURE__*/
  enumDesc(file_transportation_v1_asset, 1);

/**
 * @generated from enum transportation.v1.AssetSortOption
 */
export enum AssetSortOption {
  /**
   * @generated from enum value: ASSET_SORT_OPTION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_STATUS_ASC = 1;
   */
  STATUS_ASC = 1,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_STATUS_DESC = 2;
   */
  STATUS_DESC = 2,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_FILL_STATE_ASC = 3;
   */
  FILL_STATE_ASC = 3,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_FILL_STATE_DESC = 4;
   */
  FILL_STATE_DESC = 4,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_IDENTIFIER_ASC = 5;
   */
  IDENTIFIER_ASC = 5,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_IDENTIFIER_DESC = 6;
   */
  IDENTIFIER_DESC = 6,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_LAST_LOCATION_TIME_ASC = 7;
   */
  LAST_LOCATION_TIME_ASC = 7,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_LAST_LOCATION_TIME_DESC = 8;
   */
  LAST_LOCATION_TIME_DESC = 8,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_CREATED_AT_ASC = 9;
   */
  CREATED_AT_ASC = 9,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_CREATED_AT_DESC = 10;
   */
  CREATED_AT_DESC = 10,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_UPDATED_AT_ASC = 11;
   */
  UPDATED_AT_ASC = 11,

  /**
   * @generated from enum value: ASSET_SORT_OPTION_UPDATED_AT_DESC = 12;
   */
  UPDATED_AT_DESC = 12,
}

/**
 * Describes the enum transportation.v1.AssetSortOption.
 */
export const AssetSortOptionSchema: GenEnum<AssetSortOption> = /*@__PURE__*/
  enumDesc(file_transportation_v1_asset, 2);

/**
 * Services
 *
 * @generated from service transportation.v1.AssetQueriesService
 */
export const AssetQueriesService: GenService<{
  /**
   * @generated from rpc transportation.v1.AssetQueriesService.GetAsset
   */
  getAsset: {
    methodKind: "unary";
    input: typeof GetAssetRequestSchema;
    output: typeof GetAssetResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.AssetQueriesService.ListAssets
   */
  listAssets: {
    methodKind: "unary";
    input: typeof ListAssetsRequestSchema;
    output: typeof ListAssetsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_asset, 0);

/**
 * @generated from service transportation.v1.AssetCommandsService
 */
export const AssetCommandsService: GenService<{
  /**
   * @generated from rpc transportation.v1.AssetCommandsService.CreateAsset
   */
  createAsset: {
    methodKind: "unary";
    input: typeof CreateAssetRequestSchema;
    output: typeof CreateAssetResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.AssetCommandsService.UpdateAsset
   */
  updateAsset: {
    methodKind: "unary";
    input: typeof UpdateAssetRequestSchema;
    output: typeof UpdateAssetResponseSchema;
  },
  /**
   * @generated from rpc transportation.v1.AssetCommandsService.DeleteAsset
   */
  deleteAsset: {
    methodKind: "unary";
    input: typeof DeleteAssetRequestSchema;
    output: typeof EmptySchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_transportation_v1_asset, 1);

